import { render, staticRenderFns } from "./DownLoad.vue?vue&type=template&id=4e88e284&"
import script from "./DownLoad.vue?vue&type=script&lang=js&"
export * from "./DownLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports